import React from 'react';
import styles from './DynamicSplitLayoutSlot.scss';
export const DynamicSplitLayoutSlot = _ref => {
  let {
    children,
    width
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.dynamicSplitLayoutSlot,
    style: {
      width: `${width}%`
    }
  }, children);
};
//# sourceMappingURL=DynamicSplitLayoutSlot.js.map